import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ausencia-temporaria-page',
  templateUrl: './ausencia-temporaria-page.component.html',
  styleUrls: ['./ausencia-temporaria-page.component.css']
})
export class AusenciaTemporariaPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    
  }

}
